import React, { useContext } from 'react';
import { ActionRow } from '@womcorp/wom-miwom-ui-kit/dist/components/ActionRow';
import { ChatIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import PropTypes from 'prop-types';
import AppContext from '../../App/AppContext';
import { useGlobalData } from '../../../contextProvider/GlobalDataContext';
import { GoogleTagManager } from '../../../helpers';
import ChatContainer from './styles/ChatButtonStyled';

const ChatButton = ({ title, subtitle, showButton, from }) => {
  const { 'chat-ayuda': helpChat = {} } = useGlobalData();
  const { setShowChatbot } = useContext(AppContext);

  return helpChat?.mostrar ? (
    <ChatContainer from={from}>
      <ActionRow
        title={title}
        subtitle={subtitle}
        showButton={showButton}
        buttonText="ABRIR CHAT DE AYUDA"
        icon={<ChatIcon />}
        handleClick={() => {
          GoogleTagManager.tagInteractiveEvent({
            eventCategory: 'Chat de ayuda',
            eventAction: 'Presionar Botón - Chat de ayuda',
            eventTag: `Chat de ayuda - ${from}`,
          });

          setShowChatbot(true);
        }}
      />
    </ChatContainer>
  ) : null;
};

ChatButton.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  showButton: PropTypes.bool.isRequired,
  from: PropTypes.string.isRequired,
};

export default ChatButton;
